import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SUPPORTED_FILE_EXTENSIONS } from '~backoffice/app/~shared/constants/global.constants';
import { ProgramBannerFacade } from '~backoffice/app/~store/facades/program-banner.facade';

@Component({
  standalone: false,
  selector: 'banner-selector',
  templateUrl: './banner-selector.component.html',
  styleUrls: ['./banner-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerSelectorComponent {
  programBannerFacade = inject(ProgramBannerFacade);
  banners$ = this.programBannerFacade.banners$;
  selectedBanner$ = this.programBannerFacade.selectedBanner$;
  canUserInteract$ = this.programBannerFacade.canUserInteract$;
  supportedFileExtensions = SUPPORTED_FILE_EXTENSIONS;

  addBanner(files: File[] | null): void {
    if (files?.length) {
      this.programBannerFacade.addBanner(files[0]);
    }
  }

  selectBanner(attachmentId?: string): void {
    if (!attachmentId) return;
    this.programBannerFacade.selectBanner(attachmentId);
  }
}
